/// <reference path="../../Scripts/typings/jquery/jquery.d.ts" />
/// <reference path="../../Scripts/typings/q/Q.d.ts" />
define('services/httpclient',["require", "exports", "models/account", "services/jsonconverter", "services/settings"], function (require, exports, Account, JsonConverter, configuration) {
    "use strict";
    (function (ServiceTarget) {
        ServiceTarget[ServiceTarget["local"] = 0] = "local";
        ServiceTarget[ServiceTarget["portalApi"] = 1] = "portalApi";
        ServiceTarget[ServiceTarget["chat"] = 2] = "chat";
        ServiceTarget[ServiceTarget["publicApi"] = 3] = "publicApi";
        ServiceTarget[ServiceTarget["oneClickServiceApi"] = 4] = "oneClickServiceApi";
        ServiceTarget[ServiceTarget["clientPortalApi"] = 5] = "clientPortalApi";
    })(exports.ServiceTarget || (exports.ServiceTarget = {}));
    var ServiceTarget = exports.ServiceTarget;
    var Channel = (function () {
        function Channel(convertToCamelCase) {
            if (convertToCamelCase === void 0) { convertToCamelCase = true; }
            this._convertToCamelCase = convertToCamelCase;
        }
        Channel.prototype.getData = function (url, location) {
            return this.send(url, location, "GET", null, false);
        };
        Channel.prototype.getDataAsync = function (url, location) {
            return Q(this.send(url, location, "GET", null, true));
        };
        Channel.prototype.postData = function (url, location, data) {
            return this.send(url, location, "POST", data, false);
        };
        Channel.prototype.postDataAsync = function (url, location, data) {
            return Q(this.send(url, location, "POST", data, true));
        };
        Channel.prototype.postFileAsync = function (url, location, data) {
            var target = this.extendUrl(url, location);
            var result = jQuery.ajax({
                url: target,
                cache: false,
                contentType: false,
                processData: false,
                async: true,
                data: data,
                type: 'POST',
                beforeSend: function (req) {
                    if (Account.Session.isAuthenticated) {
                        req.setRequestHeader("Authorization", Account.Session.getAuthorizationHeader());
                    }
                }
            });
            return Q(result);
        };
        Channel.prototype.putData = function (url, location, data) {
            return this.send(url, location, "PUT", data, false);
        };
        Channel.prototype.putDataAsync = function (url, location, data) {
            return Q(this.send(url, location, "PUT", data, true));
        };
        Channel.prototype.deleteData = function (url, location, data) {
            return this.send(url, location, "DELETE", data, false);
        };
        Channel.prototype.deleteDataAsync = function (url, location, data) {
            return Q(this.send(url, location, "DELETE", data, true));
        };
        Channel.prototype.send = function (url, location, type, data, async) {
            var converter = new JsonConverter();
            var target = this.extendUrl(url, location);
            var content = converter.extend(data, null);
            content = converter.convertPropertyNamesToPascalCase(content);
            var options = this.getAjaxOptions(type, content, async);
            var response = jQuery.ajax(target, options);
            if (this._convertToCamelCase) {
                response.then(function (result) {
                    new JsonConverter().convertPropertyNamesToCamelCase(result);
                });
            }
            return response;
        };
        Channel.prototype.getAjaxOptions = function (type, data, async) {
            var contentType = 'application/json';
            if (data != null && typeof data == "string") {
                contentType = 'text/plain';
            }
            var options = {
                async: async,
                context: this,
                type: type,
                contentType: contentType,
                beforeSend: function (req) {
                    //req.setRequestHeader("Origin", configuration.Settings.getScope());
                    if (Account.Session.isAuthenticated) {
                        req.setRequestHeader("Authorization", Account.Session.getAuthorizationHeader());
                    }
                }
            };
            if (data != null) {
                if (typeof data == "string") {
                    options.data = data;
                }
                else {
                    options.data = JSON.stringify(data);
                }
            }
            return options;
        };
        Channel.prototype.extendUrl = function (url, location) {
            switch (location) {
                case ServiceTarget.local:
                    return this.makeLocalUrl(url);
                case ServiceTarget.portalApi:
                    return this.makeServiceUrl(url);
                case ServiceTarget.chat:
                    return this.makeChatUrl(url);
                case ServiceTarget.publicApi:
                    return this.makePublicApiUrl(url);
                case ServiceTarget.oneClickServiceApi:
                    return this.makeOneClickServicesApiUrl(url);
                case ServiceTarget.clientPortalApi:
                    return this.makeClientPortalApiUrl(url);
                //return this.makeServiceUrl(url);
                default:
                    return url;
            }
        };
        Channel.prototype.makeLocalUrl = function (url) {
            return configuration.Settings.getLocalPath() + url;
        };
        Channel.prototype.makeServiceUrl = function (path) {
            return configuration.Settings.getApiFor(path);
        };
        Channel.prototype.makeChatUrl = function (url) {
            return configuration.Settings.getApiForChat() + url;
        };
        Channel.prototype.makePublicApiUrl = function (path) {
            return configuration.Settings.getPublicApiFor(path);
        };
        Channel.prototype.makeOneClickServicesApiUrl = function (url) {
            return configuration.Settings.getOneClickServicesApi(url);
        };
        Channel.prototype.makeClientPortalApiUrl = function (url) {
            return configuration.Settings.getClientPortalApi(url);
        };
        return Channel;
    }());
    exports.Channel = Channel;
});

